import React from 'react';
import styled from 'styled-components';
import Input from './Input';
import Search from '../icons/Search';

const Wrapper = styled.div`
  width: 100%;
  svg {
    path {
      fill: ${(p) => p.color || '#9CA6B0'};
    }
  }
`;

export default ({ color, value, onChange, placeholder = 'Search' }) => (
  <Wrapper color={color}>
    <Input placeholder={placeholder} icon={<Search />} value={value} onChange={onChange} />
  </Wrapper>
);
